export const DEBOUNCE_DELAY_MS = Object.freeze({
  DEFAULT: 166
});
